// Product ID to single Variant ID mapping
var tangent_selected_product_map;

var default_addToCartText = "Add To Cart";
var default_addedToCartText = "Added to Cart!";
var default_add_all_to_cart_text = "Add All to Cart"
var out_of_stock_text = "Out of Stock";
var no_products_found_text ="No products found. Please retry!";

// Map variable to store add all to cart links for each sections
var sections_add_to_cart_map={};

// Tab title mapping based on tags
var tabs_title_mapping={
  section_basics:"Basics",
  section_essentials:"Essentials",
  section_works:"Works"
}


// Add default image url here
var tangent_default_selfie_image_url="https://madamekorner.com/cdn/shop/collections/head_products_1_220x@2x.jpg";
var default_variant_image_url ="https://file.tangent.ai/quiz-content/merchants/nitesh-dev-store/image/5009378275701413-no-image-2048-5e88c1b20e087fb7bbe9a3771824e743c244f437e4f8ba93bbf7b11b53f7824c_720x.webp"

var tangent_custom_tabs = document.querySelector("#tangent_custom_tabs");
var tangent_client_domain_url = window.location.origin;
var tangent_sections_wrapper_element = document.querySelector("#tangent_sections_wrapper"); 


window.onload = function() {
    var tangent_response_id = getClientResponseId()
    checkoutDataApiCall(tangent_response_id);
}

function getClientResponseId(){
  // Current Page Load URL
  var tangent_client_url = new URL(window.location.href);
  return tangent_client_url.searchParams.get("resp_id");
}

function checkoutDataApiCall(tangent_response_id){
  if (tangent_response_id != null) {
    var checkout_url = "https://service.tangent.ai/shopify/get-checkout-products?resp_id="+tangent_response_id+ "&self_serve=true" + "&multiple_variants=true";
    fetch(checkout_url)
    .then(data => {
      return data.json();
    })
    .then(response => {
      checkoutDataProcess(response);
      return response;
    })
    .catch((error) => {
      console.error('Error:', error);
    });
  }
}

function checkoutDataProcess(response){
    var tangent_recommended_products = response.products;

    var tangent_client_domain_currency = document.querySelector("#tangent_client_currency").innerText; 

    // Setting Default variant price symbol
    if (tangent_client_domain_currency == "") {
        tangent_client_domain_currency = '$';
    }

    // Setting selfie / default image
    setTangentSelfieSection(response);
  
    var tangent_product_sections = response.product_sections;
    var tangent_text_sections = response.text_sections;
    
    if(tangent_product_sections!=undefined){
      createProductSection(tangent_product_sections, tangent_text_sections);
    }    

    setTabOpen(response.tags);
    if(response.text_sections!=undefined){
      createTextSection(tangent_product_sections,tangent_text_sections);
    }

    if (tangent_recommended_products.length > 0) {
      
        tangent_selected_product_map = {};
        for (var p = 0; p < tangent_recommended_products.length; p++) {
          
          // By Default first variant is selected variant for the product
          var selected_variant = tangent_recommended_products[p].variants[0];
        
          tangent_selected_product_map[tangent_recommended_products[p].id] = tangent_recommended_products[p].variants[0].id;
          
          var product_html;

          if(tangent_product_sections!=undefined){
            for (const section in tangent_product_sections) {
              if (tangent_product_sections[section].includes(String(tangent_recommended_products[p].id))) {
                // Section product container / grid
                var product_section_grid = document.getElementById(section+"_product_grid");
                
                // Setting default / first variant data
                var product_price = selected_variant.price;
                var variant_image_url = getVariantImage(selected_variant.image_id,tangent_recommended_products[p]);
                var variant_product_url = tangent_client_domain_url + '/products/';
                variant_product_url = variant_product_url + tangent_recommended_products[p].handle + "?variant=" + selected_variant.id;

                // Product View HTML
                product_html = '<div><a id="url_tangent_product_' + p + '" class="tangent-text-link" target="_blank" href="' + variant_product_url + '"><img id="image_tangent_product_' + p + '" src="' + variant_image_url + '" class="tangent_product_image"><p class="tangent-product-title tangent_product_title_text"><b>' + tangent_recommended_products[p].title + '</b></p><p id="price_tangent_product_' + p + '" class="tangent_product_price_text">' + tangent_client_domain_currency + product_price + '</p></a><div id='+section+'_variant_'+p+'></div><a class="tangent-product-add-btn-wrapper" id="'+selected_variant.id+'" href="javascript: void(0)"><p class="tangent-btn-add tangent_add_to_cart_button" id="'+section+'_cart_tangent_product_' + p + '_text">' + default_addToCartText + '</p></a><div/>';
                
                product_section_grid.innerHTML = product_section_grid.innerHTML + product_html;

                // Enable / Disable add to cart buttons
                checkForProductValidity(tangent_product_sections,tangent_recommended_products,section,p, selected_variant);
                
              }                                
            }
          } 
        }
        enableButtonListener();
        loadElementsOnResponseData();        
    }
    else {
        document.querySelector('#tangent-general-text').innerHTML = no_products_found_text;
    }

    if (response.description == '') {
        document.querySelector('#tangent-general-text').style.display = "block";
    }
}

function setTabOpen(tags){
      // Setting 1st tab active by default
      document.querySelector("#tab-wrapper").style.display="block";

      if(tags.includes("routine_5_mins")){
        document.querySelectorAll(".tabcontent")[0].style.display="block";
        document.querySelectorAll(".tablinks")[0].classList.add("active");
      }
      else if(tags.includes("routine_10_mins")){
        document.querySelectorAll(".tabcontent")[1].style.display="block";
        document.querySelectorAll(".tablinks")[1].classList.add("active");        
      }
      else{
        document.querySelectorAll(".tabcontent")[2].style.display="block";
        document.querySelectorAll(".tablinks")[2].classList.add("active");        
      }
}

// Product available / active
function checkForProductValidity(product_sections,product_list,section,idx,selected_variant){
  var cart_button = document.getElementById(section+'_cart_tangent_product_' + idx + '_text');
  if(cart_button!=undefined){
    // Check if Product is active
    if (product_list[idx].status == "active") {
          cart_button.classList.remove("disable-btn-wrapper");
          if(selected_variant.inventory_policy == "deny"){
              if(selected_variant.inventory_quantity<1){
                if(selected_variant.inventory_management!=null){
                  cart_button.innerHTML = out_of_stock_text;
                  cart_button.classList.add("disable-btn-wrapper");
                }
                else{
                    updateSectionAllToCartLink(product_sections,product_list[idx].id,tangent_selected_product_map[product_list[idx].id]);
                }
              }
              else{
                updateSectionAllToCartLink(product_sections,product_list[idx].id,tangent_selected_product_map[product_list[idx].id]);
              }
          }
          else{
            updateSectionAllToCartLink(product_sections,product_list[idx].id,tangent_selected_product_map[product_list[idx].id]);
        }
    }
    else {
        cart_button.innerHTML = out_of_stock_text;
        cart_button.classList.add("disable-btn-wrapper");
    }
  } 
}

// Updating add all to cart object for sections
function updateSectionAllToCartLink(product_sections,product_id,vid){
    if(product_sections!=undefined){
        for (const section in product_sections) {

            // Create and add all sections cart values to a map
            if (product_sections[section].includes(String(product_id))) {
                if(sections_add_to_cart_map[section]){
                    if(!sections_add_to_cart_map[section].list.includes(vid)){
                      sections_add_to_cart_map[section].count++;
                      sections_add_to_cart_map[section].cart_link =  sections_add_to_cart_map[section].cart_link+ "&id[]=" + vid;
                      sections_add_to_cart_map[section].list.push(vid);
                      
                      // Enable / disable add all to cart based on products count
                      if(sections_add_to_cart_map[section].count>1){
                          document.getElementById(section+"_add_all_to_cart").style.display="block";
                      }
                    }
                }
                else{
                    sections_add_to_cart_map[section] = {
                        count:1,
                        cart_link: tangent_client_domain_url + "/cart/add?id[]="+vid,
                        list:[vid]
                    }
                }
            }                                
        }
    }
}

// Add all to cart function for sections
function addAllTocartFunction(section) {  
    if(sections_add_to_cart_map[section]!=undefined){
        document.getElementById(section+"_add_all_cart_link").setAttribute("href", sections_add_to_cart_map[section].cart_link);
    } 
    else {
        var x = document.querySelector("#message-text");
        x.innerHTML = "We're currently sold out of the selected product(s). Please check back later!";
        x.className = "show";
        setTimeout(function () { x.className = x.className.replace("show", ""); }, 5000);
    }
}

const getVariantImage = (imageId, product) => {
    var product_image;
    
    if(imageId!=null){
        var all_images = product.images;
        if(all_images!=undefined){
            for(var im=0;im<all_images.length;im++){
                if(imageId==all_images[im].id){
                    product_image = all_images[im].src;
                }
            }
        }
    }
    else{
        if(product.image!=null){
            product_image = product.image.src;
        }
        else{
            product_image = 'https://file.tangent.ai/quiz-content/merchants/nitesh-dev-store/image/5009378275701413-no-image-2048-5e88c1b20e087fb7bbe9a3771824e743c244f437e4f8ba93bbf7b11b53f7824c_720x.webp';
        }
    }

    if(product_image== undefined || product_image==null){
        product_image = 'https://file.tangent.ai/quiz-content/merchants/nitesh-dev-store/image/5009378275701413-no-image-2048-5e88c1b20e087fb7bbe9a3771824e743c244f437e4f8ba93bbf7b11b53f7824c_720x.webp';
    }
    return product_image;
}

// Add To Cart Function
function addToCart(btn){ 
  let formData = {
   'items': [{
    'id': btn.id,
    'quantity': 1
    }]
  };
  fetch(window.Shopify.routes.root + 'cart/add.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(formData)
  })
  .then(response => {
     if(btn!=undefined){
        if(btn.childNodes[0]!=undefined){
          btn.childNodes[0].innerHTML = default_addedToCartText;
          btn.childNodes[0].classList.add("added-to-cart-style");
        }
        else{
          btn.innerHTML = default_addedToCartText;
          btn.classList.add("added-to-cart-style"); 
        }
      }    
      document.dispatchEvent(new CustomEvent('cart:build' , {bubbles: true})); 
      document.dispatchEvent(new CustomEvent('cart:refresh', {
          bubbles: true
      })); 
      return response.json();
  })
  .catch((error) => {
    console.error('Error:', error);
  });
}

// Toggle - selfie canvas 
function selfieCanvasDisplayToggle(display){
  document.querySelector("#selfie_canvas").style.display=display;  
}

// Main Section container 
function createSectionContainer(section_name){
    var section_container = document.createElement("div");
    section_container.id=section_name+"_container";
    section_container.classList.add("tabcontent");
    return section_container;
}

// Add to cart button for sections
function createSectionAddAllToCart(section_name) {
    var add_all_to_cart_p_tag = document.createElement("p");
    add_all_to_cart_p_tag.id = section_name+"_add_all_to_cart";
    add_all_to_cart_p_tag.classList.add("section_add_all_to_cart");
    add_all_to_cart_p_tag.classList.add(section_name+"_add_all_to_cart");

    var add_all_cart_link = document.createElement("a");
    add_all_cart_link.id = section_name+"_add_all_cart_link";
    add_all_cart_link.classList.add("section_add_all_cart_link");
    add_all_cart_link.classList.add(section_name+"_add_all_cart_link");
    add_all_cart_link.href="#";
    add_all_cart_link.innerHTML = default_add_all_to_cart_text;

    // Enabling listener
    add_all_cart_link.addEventListener(
        'click',
        function () { addAllTocartFunction(section_name); },
        false
    );
    add_all_to_cart_p_tag.appendChild(add_all_cart_link);
    return add_all_to_cart_p_tag;
}

// Container having individual products
function addSectionProductGridContainer(section_name) {
    var product_grid_view_container = document.createElement("div");
    product_grid_view_container.id = section_name+"_product_grid";
    product_grid_view_container.classList.add("section_product_grid");
    product_grid_view_container.classList.add(section_name+"_product_grid");
    return product_grid_view_container;
}

// Tab buttons 
function createTabButton(section_name) {
    var tab_button = document.createElement("button");
    tab_button.id = section_name+"_tab_button";
    tab_button.innerHTML = getTabTitle(section_name);
    tab_button.name = section_name;
    tab_button.classList.add("tablinks");
    tab_button.addEventListener(
        'click',
        function () { switchTab(this); },
        false
    );
    tangent_custom_tabs.appendChild(tab_button);
}

function getTabTitle(section){
  var tab_title;
  if(tabs_title_mapping[section]!=undefined){
    tab_title = tabs_title_mapping[section];
  }
  else{
    tab_title = section.replace("section_","").replace("_"," ").toUpperCase();
  }
  return tab_title;
}

// Product Section Creation
function createProductSection(product_sections, text_sections){
    for (const section_name in product_sections) {
      // The created container will have both a container to show text and products
      var section_container = createSectionContainer(section_name);    
  
      // Creating text sections before products sections if exists
      if(text_sections!=undefined){
          createTextSectionBeforeProducts(text_sections,section_container,section_name);
      }    
      
      // Creating section to add all products
      section_container.appendChild(addSectionProductGridContainer(section_name));
  
      // Creating add all to cart button for the section    
      section_container.appendChild(createSectionAddAllToCart(section_name));

      // Add to main container wrapper
      tangent_sections_wrapper_element.appendChild(section_container);
      createTabButton(section_name);
    }
}

// Text Sections with products sections
function createTextSectionBeforeProducts(text_sections,section_container, section_name){
    if(text_sections[section_name]!=undefined){
        var section_div = document.createElement("div");
        section_div.id = section_name+"_text_container";
        section_div.classList.add("section_text_container");
        section_div.classList.add(section_name+"_text_container");
        section_div.innerHTML = text_sections[section_name].join(' ');
        section_container.appendChild(section_div);
    }
}

// Section Text Creation (one without a product section)
function createTextSection(product_sections, text_sections){
    for (const section_name in text_sections) {
        // For removing duplicate entry
        if(product_sections[section_name]==undefined){
            var section_container = createSectionContainer(section_name);

            var section_div = document.createElement("div");
            section_div.id = section_name+"_text_container";
            section_div.classList.add("section_text_container");
            section_div.classList.add(section_name+"_text_container");
            section_div.innerHTML = text_sections[section_name].join(' ');
            section_container.appendChild(section_div);  

            // To Add to top of the page container
            if(section_name == "section_selfie_type"){
              var section_selfie = document.querySelector("#section_selfie_container_parent");
              section_container.classList.remove('tabcontent');   
              section_selfie.appendChild(section_container);
            }
            else if(section_name=="section_concern"){
              var section_basic_container = document.querySelector("#section_concern_container");
              section_container.classList.remove('tabcontent');   
              section_basic_container.appendChild(section_container); 
            } 
            else{
              // Add to main container wrapper
              tangent_sections_wrapper_element.appendChild(section_container); 
            }   
        }
    }
}

// Setting Selfie / Default Image
function setTangentSelfieSection(response) {
    hideLoading();
    if(response.selfie_html!=null && response.selfie_html!=undefined){
      document.getElementById("tangent_selfie_container").innerHTML = response.selfie_html;
    }
    else{
        if(response.selfie_url!=undefined && response.selfie_url!=null){
          document.querySelector('#tangent_selfie_image').src = response.selfie_url;
        }
        else{
            if(tangent_default_selfie_image_url!=""){
                document.querySelector('#tangent_selfie_image').src = tangent_default_selfie_image_url;
            }
            else{
                document.querySelector("#tangent_selfie_container").style.display = "none";
            }
        }
    }
}

// Handle Tab button selection
function switchTab(element) {
  let i, tabcontent, tablinks;

  // This is to clear the previous clicked content.
  tabcontent = document.querySelectorAll(".tabcontent");
  for (i = 0; i < tabcontent.length; i++) {
    tabcontent[i].style.display = "none";
  }
  
  tablinks = document.querySelectorAll(".tablinks");
  for (i = 0; i < tablinks.length; i++) {
    tablinks[i].className = tablinks[i].className.replace(" active", "");
  }

  // Display the clicked tab and set it to active.
  document.getElementById(element.name+"_container").style.display = "flex";
  document.getElementById(element.name+"_tab_button").classList.add("active");
}

// Enabling button listeners
function enableButtonListener(){
    // Listner for section add all to carts
    var all_btns = document.querySelectorAll('.tangent-product-add-btn-wrapper');
    for (var b = 0; b < all_btns.length; b++) {
        all_btns[b].addEventListener(
            'click',
            function () { addToCart(this); },
            false
        );
    }
}

function loadElementsOnResponseData(){
  var all_elements = document.querySelectorAll('.load-on-data');
  for (var ae = 0; ae < all_elements.length; ae++) {
      all_elements[ae].style.display="block";
  }
}

// Hide loading
function hideLoading(){
  document.querySelector("#loading-section").style.display = "none";
}
